import { Separator, Heading, Paragraph, Card } from '@treams/treams-ui';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

const Header = styled(Box)`
	overflow: hidden;
	position: relative;

	${Paragraph} {
		position: absolute;
		right: 10px;
		top: 2px;
	}
`;

const HeaderImage = styled(Flex)`
	height: 120px;

	img {
		max-height: 58px;
		max-width: 140px;
		object-fit: contain;
		display: block;
		margin-top: 10px;
	}
`;

export default function ProductTile(props: {
	id: string;
	title: string;
	description: string;
	selected: boolean;
	logoImageURL: string;
	price?: number;
}) {
	return (
		<Card
			overflow="hidden"
			link={`/settings/integrations/${props.id}`}
			header={
				<>
					<Header py="1px" px={4}>
						<HeaderImage alignItems="center" justifyContent="center">
							<img src={props.logoImageURL} alt={props.title} />
						</HeaderImage>
					</Header>
					<Separator />
				</>
			}
			selected={props.selected}
		>
			<Flex justifyContent="space-between">
				<Heading>{props.title}</Heading>
			</Flex>
			<Paragraph>{props.description}</Paragraph>
		</Card>
	);
}
